import Person from "@/types/Person.interface"
import QboAccount from "@/types/QboAccount.interface"

interface DataProviderSyncProgress {
    message: string
    percent: number
}

interface State {
    qboAccount: QboAccount
    qboConnection: boolean
    dataProviderSyncProgress: DataProviderSyncProgress
}

const defaults = () => {
    return {
        qboAccount: null,      //  The qbo company the tenant is connected to
        qboConnection: null,   //  Bool indicating if the tenant is conncted to QBO
        dataProviderSyncProgress: null, //  QBO sync progress object
    }
}

export default {
    state: defaults(),
    mutations: {
        qboAccountSet (state: State, obj: QboAccount): void {
            state.qboAccount = obj
        },
        qboConnectionSet (state: State, bool: boolean): void {
            state.qboConnection = bool
        },
        dataProviderSyncProgressSet (state: State, obj: DataProviderSyncProgress): void {
            state.dataProviderSyncProgress = obj
        },
        qboReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        intuitLogout ({ getters }): void {
            window.intuit.ipp.anywhere.logout((): boolean => {
                getters.appDebug && console.log('INTUIT LOGOUT')
                return true
            })
        },
        qboAccountGet ({ commit, getters }): Promise<QboAccount> {
            //  Assemble the API endpoint
            const url = `${getters.api}/qbo/account`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our QBO account
                commit('qboAccountSet', response.data)

                //  Return our QBO account we got from the API
                return response.data
            }).catch(() => null)
        },
        qboConnectionTest ({ commit, getters }): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/qbo/connection`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our qbo connection to the result
                commit('qboConnectionSet', response.data.result)

                //  It worked so return true
                return true
            }).catch(() => null)
        },
        qboCustomersCount ({ getters }): Promise<number> {
            //  Assemble the API endpoint
            const url = `${getters.api}/qbo/customers/count`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Return our customer count
                return response.data
            }).catch(() => null)
        },
        qboLoad ({ getters }): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/qbo/load`

            //  Send the request
            return window.axios.get(url).then(() => {
                //  Return true since this is an async job
                return true
            }).catch((e) => e.response.status)
        },
        qboSync ({ getters }): Promise<boolean> {
            // Assemble the API endpoint
            const url = `${getters.api}/qbo/sync`

            //  Send the request
            return window.axios.get(url).then(() => {
                //  Return true since this is an async job
                return true
            }).catch((e) => e.response.status)
        },
        qboDisconnect ({ commit, getters }): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/qbo/disconnect`

            //  Send the request
            return window.axios.get(url).then(() => {
                //  We disconnected to set the connection to false
                commit('qboConnectionSet', false)

                //  We disconnected so set the qbo account to false
                commit('qboAccountSet', null)

                //  Return true since our request succeeded
                return true
            }).catch(() => null)
        }
    },
    getters: {
        qboAccount (state: State): QboAccount {
            return state.qboAccount
        },
        qboConnection (state: State): boolean {
            return state.qboConnection
        },
        qboCustomerDeleted: (_) => (person: Person): boolean => {
            //  If the person is NOT a qbo customer, return false
            // if (!person.qbo_customer) return false

            // //  Else, check if the qbo customer is deleted
            // const isDeleted = person.qbo_customer.qbo_isactive == false
            
            // //  Return the result
            // return isDeleted

            //  I cannot find any references to qbo customer anymore, so I'm defaulting to false
            return false
        },
        qboHasAccount (_, getters): boolean {
            //  Get the current tenant
            const tenant = getters.tenant

            //  IF the tenant does NOT exist, return false
            if (!tenant) return false

            //  Else, check if the tenant data provider is QBO
            const hasQbo = tenant.data_provider === 'QBO'

            //  Return the result
            return hasQbo
        },
        dataProviderSyncProgress (state: State): DataProviderSyncProgress {
            return state.dataProviderSyncProgress
        }
    }
}
